// extracted by mini-css-extract-plugin
export default {"container":"bizAppDownload_container__aJnJA","logo":"bizAppDownload_logo__8fSyQ","download-buttons":"bizAppDownload_download-buttons__EECFZ","loader":"bizAppDownload_loader__ANWAe"};